import { useContext, Dispatch } from 'react';
import { SchedulesAction, SchedulesState } from '../types';
import { SchedulesContext } from '../contexts';

export function useSchedulesContext(): { state:SchedulesState, dispatch: Dispatch<SchedulesAction>} {
  const {state, dispatch} = useContext(SchedulesContext);
  return {state, dispatch};
}
